import { connect } from "react-redux";
import withSignalGetter from "./with-signal-getter";
import compose from "../utils/compose";

import { changeIntervalSelectorGraphSettings } from "../redux/actions/report-actions";

const mapStateToProps = ({
    reportApp: {
        reportData: {
            settings: {
                graphs: {
                    graphIntervalSelector: { channel, timeScale_mm_s, desiredCenter_pnt }
                }
            },
            report: {
                signal: { fd, channelNames, signalLength }
            }
        }
    }
}) => {
    return {
        channel,
        timeScale_mm_s,
        desiredCenter_pnt,
        fd,
        channelNames,
        signalLength
    };
};

const mapDispatchToProps = {
    changeSettings: changeIntervalSelectorGraphSettings
};

export const prepareSelectorHOC = component => {
    return compose(withSignalGetter, connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true }))(component);
};
